// Re-export so Ember Data can resolve the singular model name 'report'
// which the JSONAPISerializer produces from the API type 'reports'.
export { default } from './reports';
export type {
  SearchConfig,
  SearchConfigFilters,
  ReportMetadata,
  ReportScope,
  ChartMetadata,
  ChartSettings,
  TableSettings,
  RangeBucket,
} from './reports';
